import { inject as injector } from '../../mixins/registrable'
import Expand from '../../mixins/expand-transition'
import Toggleable from '../../mixins/toggleable'
import { findChildComponents } from '../../utils/helpers'


export default {
  name: 'list-group',

  mixins: [injector('list', 'list-group', '<n-list>'), Expand, Toggleable],

  props: {
    groupPath: String,
    tag: { type: String, default: 'li' },
  },

  computed: {
    classes () {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
      }
    },
  },

  watch: {

    isActive() {
      if(this.isActive) this.$emit('list-group-activated', this)
    },

    '$route':{
      handler(to) {
        this.checkForGroupPathRouteMatch()
      },
      immediate: true,
    }
  },

  created() {
    this.list.register(this)
  },

  methods: {

    /**
     * Check if the current route matches this group's `groupPath`
     * If there is a match, it will open this group (isActive = true) as well as
     * the parent groups that contain this group - if any
     * 
     * If this group doesn't match the current route, it will be closed
     */
    checkForGroupPathRouteMatch() {
      if (this.groupPath) {
        let willActivate = this.matchRoute(this.$route.path)

        // Group will be opened - open it's parent groups as well
        if(willActivate) {
          let groups = []
          let node = this
          while(node != null) { // look up the parent tree 
            if(node.$options._componentTag == 'n-list-group')
              groups.push(node)
            node = node.$parent
          }

          groups.reverse().forEach(group => group.isActive = true) // open (from top down)
        }
        else {
          // Only close if this group doesn't contain another group that is about to be opened because it matches the route
          let containsActiveGroup = findChildComponents(this, child => child.$options._componentTag == 'n-list-group')
            .some(childGroup => childGroup.matchRoute(this.$route.path))
            
          this.isActive = containsActiveGroup

        }
      }
    },

    onItemClick() {
      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        this.isActive = !this.isActive
      }
    },

    matchRoute (to) {
      if (!this.groupPath) return false
      return to.match(this.groupPath) !== null
    }
  },

  render (h) {
    const group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.$slots.default])

    const transition = h('transition', {
      on: {
        enter: this.enter,
        afterEnter: this.afterEnter,
        leave: this.leave
      }
    }, [group])

    const item = h('div', {
      'class': this.classes,
      on: { click: this.onItemClick },
      ref: 'item'
    }, [this.$slots.item])

    return h(this.tag, { 'class': 'list__item' }, [item, transition])
  },

  beforeDestroy () {
    this.list.unregister(this)
  },
}